import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';

import { formatCurrency } from '~libs/dataUtils';

import { SectionTotal } from '~support-at-home/models';

interface ComponentProps {
  amount?: number;
  totals?: SectionTotal;
  includesCaseManagement?: boolean;
}

const styles = StyleSheet.create({
  container: {
    width: '33%',
    minWidth: 160,
    marginLeft: 'auto',
    fontSize: 10,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 2,
    marginBottom: 2,
    paddingLeft: 2,
  },
  underline: {
    borderBottom: '1px solid #949494',
    paddingBottom: 10,
    paddingLeft: 2,
  },
  overline: {
    borderTop: '1px solid #949494',
    paddingTop: 2,
    paddingLeft: 2,
  },
  doubleOverline: {
    borderTop: '1px solid #949494',
    borderBottom: '1px solid #949494',
    height: 3,
    marginBottom: 2,
  },
  label: {
    textAlign: 'left',
    flex: 1,
    fontWeight: 'bold',
    fontSize: 8,
  },
  value: {
    textAlign: 'right',
    flex: 1,
    fontWeight: 'bold',
    fontSize: 8,
    paddingLeft: 8,
  },
  caseManagement: {
    color: '#198754',
  },
});

const GrandTotal: React.FC<ComponentProps> = ({ totals, includesCaseManagement }) => {
  const { cost, contribution, govSubsidy, case_management } = totals || {};

  return (
    <View style={styles.container}>
      {includesCaseManagement !== undefined && includesCaseManagement !== null && (
        <View style={[styles.row, styles.overline]}>
          <Text style={[styles.label, styles.caseManagement]}>Case Management</Text>
          <Text style={styles.value}>{formatCurrency(case_management, 0)}</Text>
        </View>
      )}
      <View style={styles.doubleOverline} />
      <View style={styles.row}>
        <Text style={styles.label}>Grand Total</Text>
        <Text style={styles.value}>{formatCurrency(cost, 0)}</Text>
      </View>
      <View style={[styles.row, styles.overline]}>
        <Text style={styles.label}>Co-Contribution</Text>
        <Text style={styles.value}>{formatCurrency(contribution, 0)}</Text>
      </View>
      <View style={styles.row}>
        <Text style={styles.label}>Gov. Contribution</Text>
        <Text style={styles.value}>{formatCurrency(govSubsidy, 0)}</Text>
      </View>
    </View>
  );
};

export default GrandTotal;
